import { render, staticRenderFns } from "./AsignarTransportistas.vue?vue&type=template&id=6323aa4b&"
import script from "./AsignarTransportistas.vue?vue&type=script&lang=js&"
export * from "./AsignarTransportistas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports